<div class="c-card c-card--new-terms">
  <div class="c-card__inner">
    <div class="c-card__header">
      <div class="c-card__header-left">
        <div class="c-card__square">#{{ row?.id || row?.key }}</div>
        <div class="c-card__title">
          {{ row?.name }}
        </div>
      </div>
      <div class="c-card__left-body">
        <div class="c-card__left-top" *ngIf="!viewOnly">
          <div *actionRbac="RbacPermissionsConstant.COMMANDS_TERMS_CREATE_EDIT" class="c-card__button ml-auto">
            <button p500-ui-button-icon color="primary" transparent="true" (click)="edit(row?.id)">
              <p500-ui-icon name="pencil-underline"></p500-ui-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="c-card__footer mt-14">
      <div class="c-card__add-info">
        <div class="c-card__info-row">
          {{ modelLocalization.get(row?.model) ?? row?.model }}:&nbsp;
          <span>
            {{ aggregateLocalization.get(row?.aggregate) ?? row?.aggregate }} <span i18n="@@common.of">of</span> {{ row?.target }}
          </span>
        </div>
        <div class="c-card__info-row" *ngIf="!viewOnly">
          <span i18n="@@common.conditions">Conditions</span>:&nbsp;&nbsp;
          <gtd-ui-field-default-conditions *ngIf="row?.filters?.length" [conditionsData]="row?.filters"></gtd-ui-field-default-conditions>
          <gtd-ui-field-empty-component *ngIf="!row?.filters?.length"></gtd-ui-field-empty-component>
        </div>
        <div class="c-card__info-row">
          <span i18n="@@common.format">Format</span>: {{ formatLocalization.get(row?.format) ?? row?.format }}
        </div>
        <div class="c-card__info-row" *ngIf="!viewOnly">
          <span i18n="@@common.created_at">Created At</span>:&nbsp;<gtd-ui-field-default-datetime
            [data]="row?.created_at_timestamp"
          ></gtd-ui-field-default-datetime>
        </div>
      </div>
      <div class="c-card__description mt-14">
        <div class="c-card__info-row">
          <span i18n="@@common.description">Description</span>:&nbsp;
          <span *ngIf="row?.description?.length" [class.one-row]="!viewOnly">{{ row?.description }}</span>
          <gtd-ui-field-empty-component *ngIf="!row?.description?.length"></gtd-ui-field-empty-component>
        </div>
      </div>
    </div>
  </div>
</div>
